/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlagUsLegacy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={26}
      height={13}
      viewBox='0 0 26 13'
      {...props}
    >
      <defs>
        <g id='flag-us-legacy_svg__b'>
          <use xlinkHref='#flag-us-legacy_svg__a' />
          <use x={1.667} xlinkHref='#flag-us-legacy_svg__a' />
          <use x={3.333} xlinkHref='#flag-us-legacy_svg__a' />
          <use x={5} xlinkHref='#flag-us-legacy_svg__a' />
          <use x={6.667} xlinkHref='#flag-us-legacy_svg__a' />
        </g>
        <g id='flag-us-legacy_svg__c'>
          <use xlinkHref='#flag-us-legacy_svg__b' />
          <use x={8.333} xlinkHref='#flag-us-legacy_svg__a' />
        </g>
        <g id='flag-us-legacy_svg__e'>
          <use xlinkHref='#flag-us-legacy_svg__c' />
          <use x={0.833} y={0.7} xlinkHref='#flag-us-legacy_svg__b' />
          <use y={1.4} xlinkHref='#flag-us-legacy_svg__c' />
          <use x={0.833} y={2.1} xlinkHref='#flag-us-legacy_svg__b' />
          <use y={2.8} xlinkHref='#flag-us-legacy_svg__c' />
          <use x={0.833} y={3.5} xlinkHref='#flag-us-legacy_svg__b' />
          <use y={4.2} xlinkHref='#flag-us-legacy_svg__c' />
          <use x={0.833} y={4.9} xlinkHref='#flag-us-legacy_svg__b' />
          <use y={5.6} xlinkHref='#flag-us-legacy_svg__c' />
        </g>
        <path id='flag-us-legacy_svg__d' fill='#B22234' d='M0 0h26v1H0z' />
        <path
          id='flag-us-legacy_svg__a'
          fill='#FFF'
          d='M.518.44L.75.272H.464L.375 0 .286.272H0L.232.44.143.713.375.545l.232.168z'
        />
      </defs>
      <path fill='#FFF' d='M0 0h26v13H0z' />
      <use xlinkHref='#flag-us-legacy_svg__d' />
      <use y={2} xlinkHref='#flag-us-legacy_svg__d' />
      <use y={4} xlinkHref='#flag-us-legacy_svg__d' />
      <use y={6} xlinkHref='#flag-us-legacy_svg__d' />
      <use y={8} xlinkHref='#flag-us-legacy_svg__d' />
      <use y={10} xlinkHref='#flag-us-legacy_svg__d' />
      <use y={12} xlinkHref='#flag-us-legacy_svg__d' />
      <path fill='#3C3B6E' d='M0 0h10v7H0z' />
      <use x={0.458} y={0.343} xlinkHref='#flag-us-legacy_svg__e' />
    </svg>
  );
}

export default SvgFlagUsLegacy;
